<script>
export default {
    name: 'BaseChecklist',

    props: {
        values: {
            type: Array,
        },

        options: {
            type: Array,
        },
    },

    data() {
        return {
            uid: undefined,
            isTouchDevice: undefined,
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'checkbox' + Math.random()
            this.isTouchDevice = 'ontouchstart' in document.documentElement
        }
    },

    methods: {
    }
}
</script>

<template>
    <fieldset class="base-checklist" :class="{ 'not-touch-device': !isTouchDevice }">
        <div class="before">
            <slot name="before" />
        </div>
        <label
            v-for="(option, i) in options"
            :key="option.name"
            :id="option.id"
            :for="`${uid}_${i}`"
            :class="[{ 'is-checked': values && values.includes(option.value) }, option.classname]"
        >
            <input
                type="checkbox"
                v-on="$listeners"
                :value="option.value"
                :id="`${uid}_${i}`"
                v-bind="$attrs"
                :checked="values && values.includes(option.value)"
            />
            <div class="label-text">
                <slot name="label" :option="option">
                    {{ option.name }}
                </slot>
            </div>
            <div class="after-option">
                <slot name="after-option">
                </slot>
            </div>
        </label>
        <div v-if="taggable && values && values.length">
            <span v-html="tagText"></span> <div :class="`tags ${tagsClassname}`">
                <div :class="`tag ${tagClassname}`" v-for="tag in values" :key="getTagKey(tag)">
                    {{ getTagValue(tag) }}
                    <div class="remove" @click="handleRemoveClick(tag)">
                        <IconCross style="width:10px" />
                    </div>
                </div>
            </div>
        </div>
        <div class="after">
            <slot name="after" />
        </div>
    </fieldset>
</template>

<style lang="stylus">
@import '../assets/stylus/vars.styl'

// reset fieldset style
legend
    padding 0
    display table

fieldset
    border 0
    padding 0.01em 0 0 0
    margin 0
    min-width 0

body:not(:-moz-handler-blocked) fieldset
    display table-cell


.base-checklist
    
    & > label + label
        margin-top 16px

    .before:empty
    .after:empty
    .after-option:empty
        display none

    label
        transition background-color ease .3s
        background-color $AkWhite
        border-radius 10px
        display flex
        align-items center
        min-height 64px
        padding-left 16px
        padding-right 16px
        flex-direction row-reverse
        justify-content space-between
        cursor pointer
        border 1px solid var(--color3)
        border-radius 10px

        &.is-checked
            background-color var(--color3)
            border-color var(--color3)

            .label-text
                color var(--color3Inverse)

        &:has(:focus-visible)
            outline 2px solid black
            outline-offset -1px

    input
        margin 0
        padding 0

    .label-text
        font-size 14px
        color $AkGreyscaleBlack

    .tags
        margin-top 10px
        display inline-flex

    .tag
        display inline-flex
        padding 5px
        margin-right 5px
        font-weight 600
        align-items center

        .remove
            cursor pointer
            display inline-block
            margin-left 7px
            font-weight normal
            font-size 18px
            color var(--AkGreyscaleDarkGrey)

    &.not-touch-device label:hover
        background-color var(--color3)
        border-color var(--color3)

        .label-text
            color var(--color3Inverse)

.base-checklist-bar-vertical
    label
        min-height 0
        padding-top 16px
        padding-bottom 16px
        flex-direction column-reverse
        justify-content space-between
        text-align center

    .label-text
        font-size 14px
        color $AkGreyscaleBlack
        margin-left 0
        padding-bottom 10px
        font-weight 500

        & > div
            display flex
            flex-direction column
            align-items center

    input
        width 15px
        height 15px

</style>
